$(function () {
  $("#task-select2-teacher").select2();
  $("#task-select2-student").select2();
});